export default "__VITE_ASSET__fnIiZpoG__"